import * as signalR from "@microsoft/signalr";

class SignalRService {
    //constructor() {
    //    this.connection = null;
    //    this.isConnected = false;
    //}
    constructor() {
        this.connection = null;
        this.messageListeners = [];
    }

    startConnection() {


        const baseUrl = sessionStorage.getItem('server_api_url');
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(baseUrl.replace("/api", "") + "fciHub")
            .withAutomaticReconnect([0, 2000, 10000, 30000])
            .build();

        //this.connection.on("SyncingWirelessLines", (message) => {
        //    if (this.onMessageReceived && typeof message === 'string') {
        //        //alert(message);
        //        this.onMessageReceived(message);
        //    }
        //});

        this.connection.on("SyncingWirelessLines", this.handleReceiveMessage.bind(this));

        this.connection.start()
            .then(() => {
                console.log('SignalR connection established.');
            })
            .catch(err => {
                console.error('Error starting SignalR connection:', err);
            });

        this.connection.onreconnecting(error => {
            console.warn(`Connection lost due to ${error}. Reconnecting...`);
        });

        this.connection.onreconnected(connectionId => {
            console.log(`Reconnected successfully with connectionId: ${connectionId}`);
        });

        this.connection.onclose(error => {
            console.error('SignalR connection closed due to error:', error);
        });
    }

    handleReceiveMessage(message) {
        this.messageListeners.forEach(callback => callback(message));


    }

    subscribeToMessages(callback) {
        this.messageListeners.push(callback);
    }

    unsubscribeFromMessages(callback) {
        this.messageListeners = this.messageListeners.filter(listener => listener !== callback);
    }

    stopConnection() {
        if (this.connection) {
            this.connection.stop();
        }
    }
}
const signalRService = new SignalRService();
export default signalRService;
